import { render, staticRenderFns } from "./RegistroViajerosAgencia.vue?vue&type=template&id=b8c77dd6&scoped=true"
import script from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
export * from "./RegistroViajerosAgencia.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajerosAgencia.vue?vue&type=style&index=0&id=b8c77dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c77dd6",
  null
  
)

export default component.exports